import _ from "lodash";

export default {
	data() {
		return {
			data: null,
			comments: null,
			extraData: null,
			extraInfo: null,
			noFiles: null,
			editingComments: false,
			initialized: false,
		};
	},

	props: {
		showQuestionNumber: {
			required: false,
			type: Boolean,
			default() {
				return true;
			},
		},
		question: {
			required: true,
			type: Object,
		},
		updateForm: {
			required: true,
			type: Function,
		},
		files: {
			required: true,
			type: Array,
		},
		questionFiles: {
			required: true,
			type: Function,
		},
		setKey: {
			required: false,
			type: String,
			default() {
				return "answer";
			},
		},
	},

	computed: {
		questionClass() {
			let classes = {
				"ta-form__question--highlight": this.highlightIncompleteQuestions && !this.getQuestionIsAnswered(this.question),
				"ta-form__question--answered": this.getQuestionIsAnswered(this.question),
				"ta-form__question--disabled": !this.getQuestionIsRequired(this.question),
				"animate--shake": this.question.formattedId === this.flashedQuestion,
			};
			classes["ta-form__question--" + this.question.formattedId] = this.question.formattedId;
			return classes;
		},
		questionInfo() {
			return this.question.info;
		},
		questionNumber() {
			return (this.question.id || this.question.number).split("_").pop();
		},
		questionIsAnswered() {
			return this.getQuestionIsAnswered(this.question);
		},
		showExtraDataField() {
			return _.indexOf(_.values(this.questionInfo?.requirements || []), "extraData") > -1;
		},
		showExtraInfoField() {
			return _.indexOf(_.values(this.questionInfo?.requirements || []), "extraInfo") > -1;
		},
		showFilesManager() {
			return _.indexOf(_.values(this.questionInfo?.requirements || []), "files") > -1;
		},
		showComments() {
			return this.editingComments || this.comments;
		},
	},

	methods: {
		getQuestionInfo(question, key, defaultValue = null) {
			return question.info?.[key] ?? defaultValue;
		},
		getQuestionIsRequired(question) {
			return this.getQuestionInfo(question, "required", _.filter(question.questions || {}, (question) => {
				return !this.getQuestionIsRequired(question);
			}).length === 0);
		},
		getQuestionIsAnswered(question) {
			return question.info.complete;
			// return this.getQuestionInfo(question, "complete", _.filter(question.questions, (question) => {
			// 	return !this.getQuestionIsAnswered(question);
			// }).length === 0);
		},
		getQuestionIsDisabled(question) {
			return this.getQuestionInfo(question, "disabled", _.filter(question.questions || {}, (question) => {
				return !this.getQuestionIsDisabled(question);
			}).length === 0);
		},
		deleteComments() {
			this.editingComments = false;
			this.form.set("answers." + this.formattedQuestionId(this.question.id), null, "comments");
		},
	},

	created() {
		new Promise((resolve) => {
			this.data = this.question.info?.[this.setKey] || null;
			this.comments = this.question.info?.comments || null;
			this.extraInfo = this.question.info?.extraInfo || null;
			this.noFiles = this.question.info?.noFiles || null;
			resolve();
		}).finally(() => {
			this.initialized = true;
		});
	},

	watch: {
		"comments": {
			immediate: false,
			handler: _.debounce(function () {
				this.updateForm(this.question, "comments", this.comments, this.initialized);
			}, 3000),
		},
		"extraInfo": {
			immediate: false,
			handler: _.debounce(function () {
				this.updateForm(this.question, "extraInfo", this.extraInfo, this.initialized);
			}, 3000),
		},
		"noFiles": {
			handler: function () {
				this.updateForm(this.question, "noFiles", this.noFiles, this.initialized);
			},
		},
	},
};
